import { setDiscoveryRulesEdited as setDiscoveryRulesEditedDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    edited?: boolean;
}

export const setDiscoveryRulesEdited = ({
    edited,
}: Props) => setDiscoveryRulesEditedDiagram({
    edited,
});

